import { AIChat } from '@/components/features/ai/AIChat';
import { Maskot } from '@/components/features/maskot/Maskot';
import { MASKOT_RANNA } from '@/lib/maskot';

export function AIPage() {
  return (
    <div className={`flex-1 flex overflow-hidden p-4 sm:p-6 gap-6 ${MASKOT_RANNA}`}>
      <AIChat />
      <Maskot vem="elvis" bubbla="fråga mig om producentansvar, koder och avgifter. Jag svarar med källor ur kunskapsbasen." />
    </div>
  );
}
